import React, { useState, useContext } from 'react';
import { Alert, Button, Stack } from '@mui/material';
import { AuthContext } from '../auth/AuthContext';

export default function ContrattoBanner() {
  const { user } = useContext(AuthContext);
  if(!user || !user.role) return null;
  if (user.role==="ADMIN" || user.statoContratto==="") return null;

  if (user.statoContratto === 'ATTIVO' && user.giorniResidui > 30) {
    return null;
  }

  const severity =
    user.statoContratto === 'ATTIVO' ? 'warning' : 'error';

  const message = {
    ATTIVO: `Il tuo abbonamento scade tra ${user.giorniResidui} giorni.`,
    IN_ATTESA_PAGAMENTO: 'Pagamento non completato. Accesso limitato, 15 giorni con limitazione alla creazione di documenti',
    SCADUTO: 'Abbonamento scaduto. Accesso limitato, 15 giorni con limitazione alla creazione di documenti',
    SOSPESO: 'Account sospeso.'
  }[user.statoContratto];

  return (
    <Alert severity={severity} sx={{ mb: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {message}
        <Button
          color="inherit"
          size="small"
          href={`/contratti/${user.contrattoId}`}
        >
          Visualizza
        </Button>
      </Stack>
    </Alert>
  );
}